import moment from 'moment';
import * as actions from './constants';
import getClient from 'api';
import {
  addCustomError,
  addGlobalError,
  startLoading,
  stopLoading,
} from 'components';
import { INTERNAL_SERVER_ERROR_CODE, NO_INVOICE_MESSAGE, V2 } from 'constant';
import { downloadPDF, invoicePayload, populateInvoicePayload } from 'utils';

const client = getClient();

//ADD_INVOICES
export const addInvoices = payload => ({
  type: actions.ADD_INVOICES,
  payload,
});

export const startAddInvoices = ({
  pageNumber = 1,
  searchElement = '',
  startDate = moment()
    .subtract(3, 'month')
    .format('YYYY-MM-DD'),
  toDate = moment().format('YYYY-MM-DD'),
  pageSize = 10,
  isRecursive = true,
  billToSiteNumber,
}) => (dispatch, getState) => {
  dispatch(startLoading());
  const {
    startDate: startDateFilter,
    toDate: toDateFilter,
    invoiceName,
  } = getState().invoices.filter;

  const { moonshotInvoiceFlag } = getState().invoices;

  if (startDateFilter && isRecursive) {
    startDate = startDateFilter;
    toDate = toDateFilter;
  } else if (invoiceName && isRecursive) {
    searchElement = invoiceName;
    startDate = '';
    toDate = '';
  } else {
    startDate = moment()
      .subtract(3, 'month')
      .format('YYYY-MM-DD');
    toDate = moment().format('YYYY-MM-DD');
  }

  return new Promise(resolve => {
    const payload = { ...invoicePayload };
    const version = moonshotInvoiceFlag ? V2 : '';

    const getInvoices = pageNumber =>
      client
        .get(`/api/platform-billing-orchestration/invoice${version}`, {
          params: {
            pageNumber: pageNumber,
            searchElement: searchElement,
            pageSize: pageSize,
            startDate: startDate,
            toDate: toDate,
            billToSiteNumber: billToSiteNumber,
          },
        })
        .then(response => {
          populateInvoicePayload(payload, response);

          if (isRecursive && pageNumber < response.data.totalPages) {
            getInvoices(pageNumber + 1);
          } else {
            dispatch(addInvoices(payload));
            dispatch(stopLoading());
            resolve();
          }
        })
        .catch(error => {
          dispatch(addInvoices(invoicePayload));
          dispatch(addGlobalError(error));
          dispatch(stopLoading());
          resolve();
        });

    getInvoices(pageNumber);
  });
};

export const startAddSummaryInvoices = billToSiteNumber => dispatch => {
  dispatch(startLoading());
  return client
    .get(
      `/api/platform-billing-orchestration/summary/invoices?billToSiteNumber=${billToSiteNumber}`
    )
    .then(response => {
      const payload = populateInvoicePayload({ ...invoicePayload }, response);

      dispatch(addInvoices(payload));
      dispatch(stopLoading());
    })
    .catch(error => {
      error?.response?.status === INTERNAL_SERVER_ERROR_CODE
        ? dispatch(addCustomError(NO_INVOICE_MESSAGE))
        : dispatch(addGlobalError(error));
      dispatch(stopLoading());
    });
};

//SET_DATE_FILTER
export const setDateFilter = payload => ({
  type: actions.SET_DATE_FILTER,
  payload,
});

//SET_INVOICE_NAME_FILTER
export const setInvoiceNameFilter = payload => ({
  type: actions.SET_INVOICE_NAME_FILTER,
  payload,
});

//SET_INVOICE_NAME_FILTER
export const clearInvoices = () => ({
  type: actions.CLEAR_INVOICES,
});

//SET_INVOICE_NAME_FILTER
export const getInvoicePDF = payload => ({
  type: actions.GET_INVOICE_PDF,
  payload,
});

export const startGetInvoicePDF = eventId => {
  const pdfClient = getClient({
    responseType: 'blob',
  });
  return (dispatch, getState) => {
    dispatch(startLoading());
    const { moonshotInvoiceFlag } = getState().invoices;
    const version = moonshotInvoiceFlag ? V2 : '';

    return pdfClient
      .get(
        `/api/platform-billing-orchestration/invoice/pdf${version}?eventId=${eventId}`
      )
      .then(response => {
        downloadPDF(response.data, eventId);
        dispatch(getInvoicePDF(response.data));
        dispatch(stopLoading());
      })
      .catch(error => {
        dispatch(addGlobalError(error));
        dispatch(stopLoading());
      });
  };
};

export const setMoonshotInvoiceFlag = payload => ({
  type: actions.SET_MOONSHOT_INVOICE_FLAG,
  payload,
});
